import React from 'react';
import { 
  Box, 
  Card, 
  CardContent, 
  Grid, 
  Typography, 
  IconButton,
  Tooltip,
  Box as MuiBox
} from '@mui/material';
import {
  Warning,
  Check,
  Close,
} from '@mui/icons-material';
import dayjs from 'dayjs';

const BookingMobileView = ({ bookings, navigateBooking, statusMapping, t, bookingAction }) => {
  return (
    <Box sx={{ mt: 2 }}>
      {bookings?.map((item, index) => {
        const formattedStartTime = item?.planned_start_time ? dayjs(item.planned_start_time, 'HH:mm').format('HH:mm') : '';
        const formattedEndTime = item?.planned_end_time ? dayjs(item.planned_end_time, 'HH:mm').format('HH:mm') : '';
        const formattedDate = `${dayjs(item?.planned_start_day).format('DD/MM/YYYY')} ${formattedStartTime} - ${formattedEndTime}`;
        const formattedTenant = item?.member?.user?.first_name + ' ' + item?.member?.user?.last_name || '';

        return (
          <Card
            key={index}
            sx={{
              mb: 2,
              cursor: 'pointer',
              '&:hover': { backgroundColor: '#f5f5f5' },
              position: 'relative'
            }}
            onClick={() => navigateBooking(item)}
          >
            <CardContent>
              <Grid container spacing={1}>
                {/* Status Badge for PC items */}
                {item?.status === 'PC' && (
                  <Grid item xs={12} sx={{ mb: 1 }}>
                    <MuiBox
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        backgroundColor: 'error.main',
                        color: 'common.white',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        fontSize: '0.875rem',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          backgroundColor: 'error.dark',
                          '& .actions': {
                            display: 'flex'
                          },
                          '& .alert': {
                            display: 'none'
                          }
                        }
                      }}
                    >
                      <MuiBox
                        className="alert"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          width: '100%',
                          justifyContent: 'center'
                        }}
                      >
                        <Warning fontSize="small" />
                        <Typography variant="body2">
                          {t('Pending Confirmation')}
                        </Typography>
                      </MuiBox>

                      <MuiBox
                        className="actions"
                        sx={{
                          display: 'none',
                          position: 'absolute',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          gap: 2
                        }}
                      >
                        <Tooltip title={t('Confirm Booking')} arrow>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              bookingAction(item?.slug, 'accept');
                            }}
                            sx={{
                              color: 'success.main',
                              backgroundColor: 'white',
                              '&:hover': {
                                backgroundColor: 'white',
                              }
                            }}
                          >
                            <Check fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t('Decline Booking')} arrow>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              bookingAction(item?.slug, 'reject');
                            }}
                            sx={{
                              color: 'error.main',
                              backgroundColor: 'white',
                              '&:hover': {
                                backgroundColor: 'white',
                              }
                            }}
                          >
                            <Close fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </MuiBox>
                    </MuiBox>
                  </Grid>
                )}

                {/* Regular content */}
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">{t('Date')}:</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{formattedDate}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">{t('Status')}:</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography 
                    variant="body2"
                    sx={{
                      color: item?.status === 'PC' ? 'error.main' : 'inherit'
                    }}
                  >
                    {statusMapping[item?.status]}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">{t('Customer')}:</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{formattedTenant}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">{t('Code')}:</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body2">{item?.code}</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
};

export default BookingMobileView;